import { pipe, flow } from 'fp-ts/function';
import { createAuthorizedDeleteRequest, createAuthorizedPostRequest, createAuthorizedPutRequest, fetchApi, setBody } from '@/services/api';
import { chain, map, mapLeft } from 'fp-ts/TaskEither';
import { toasted } from '@/ui/helpers';
import { fetchUser } from '@/ui/auth/auth';

const baseUrl = '/v2/cb/subscriptions';
const subscriptionUrl = (subscription: string) => `${baseUrl}/${subscription}`;
const discountUrl = (subscription: string) => `/v2/discount/${subscription}`;
const restoreUrl = (subscription: string) => `${baseUrl}/restore/${subscription}`;

type CreateSubscriptionBody = {
  slug: string;
  quantity?: number | string | null;
};

const freeTrialSubscriptionBody: CreateSubscriptionBody = { slug: 'Professional-EUR-Monthly', quantity: null };

export const postSubscription = (data: CreateSubscriptionBody | null = freeTrialSubscriptionBody) => pipe(
  baseUrl,
  createAuthorizedPostRequest,
  map(setBody({ plan: data })),
  chain(fetchApi),
);

export const startTrial = flow(
  postSubscription,
  mapLeft(e => {
    toasted.error(e.message);
  }),
  map(async () => {
    await fetchUser()();
  }),
);

export const updateSubscription = (subscription: string, quantity: number | null = null) => pipe(
  subscriptionUrl(subscription),
  createAuthorizedPutRequest,
  map(setBody({ quantity })),
  chain(fetchApi),
);

export const cancelSubscription = (subscription: string) => pipe(
  subscriptionUrl(subscription),
  createAuthorizedDeleteRequest,
  chain(fetchApi),
);

export const restoreSubscription = (subscription: string) => pipe(
  restoreUrl(subscription),
  createAuthorizedPutRequest,
  map(setBody({})),
  chain(fetchApi),
);

export const applyForDiscount = (subscription: string) => pipe(
  discountUrl(subscription),
  createAuthorizedPutRequest,
  map(setBody({})),
  chain(fetchApi),
);
